import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";

import {
  DataStateChangeEventArgs,
  DatePickerEditCell,
  EditSettingsModel,
  GridComponent,
  PageSettingsModel,
  QueryCellInfoEventArgs,
  RowSelectEventArgs,
} from "@syncfusion/ej2-angular-grids";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonHttpService } from "src/app/common.service";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { runInThisContext } from "vm";
import { PurchaseListService } from "./purchase-request-dataservice";
import {
  DeletepermissionBO,
  functionpermission,
  GetPurchaseBase,
  purchaseBo,
  PurchaseReceiptBO,
  PurchaseRequestBO,
  servicedropdown,
  VendorBO,
} from "./purchase-request.model";
import { PurchaseRequestService } from "./purchase-request.service";
import { BulkT2025UpdateBO, MultipleAccecpt_RejectBO } from "../evvtimesheet/evvtimesheet.model";
import { element } from "protractor";

@Component({
  selector: "app-purchase-request",
  templateUrl: "./purchase-request.component.html",
  styleUrls: ["./purchase-request.component.scss"],
})
export class PurchaseRequestComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() purchaseEmit = new purchaseBo();
  purchaseBO: PurchaseRequestBO = new PurchaseRequestBO();
  PurchaseRequest:PurchaseRequestBO =new PurchaseRequestBO();
  purchaseFileBo: PurchaseReceiptBO = new PurchaseReceiptBO();
  clientList: any;
  purchaseTypeList: any;
  purchaseType: string[]=[];
  EditPurchaseType:string;
  vendorList: any;
  AuthList: any;
  payer: string;
  serviceName: string;
  purchaseId: string;
  isview = false;
  purchaselistBo: GetPurchaseBase = new GetPurchaseBase();
  acceptError: string;
  PurchaseStatusList: any;
  getAuthId: string;
  purchaseClientName: string;
  documentType: string = "";
  fileUpload: any;
  servicedropdown: [
    {
      key: null;
      value: null;
    }
  ];
  purchaseAuthGrid: any = []
  showNoAgenyError = false
  vendor: VendorBO = new VendorBO();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public initialPage: PageSettingsModel;
  @ViewChild("grid") public grid: GridComponent;
  public gridPurchase: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public formatDateOptions: object;
  public editSettings: EditSettingsModel;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    // disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true,
  };
  public myDatePickerRestrictOptions: IMyDpOptions = {
    ...this.myDatePickerOptions
  }
  stateList: any;
  form: FormGroup;
  IsButtonDisable: boolean = false;
  DeleteForm: FormGroup;
  deletebo: DeletepermissionBO = new DeletepermissionBO();
  validationError: boolean = false;
  private DecimalColumns: string[] = ["RATE", "TOTALAMOUNT"];
  PurchaseRequestList:PurchaseRequestBO[]=[]
  public filterDropDownData: string[] = ['True', 'False'];
  popupHeight: string = '220px';
  //@ViewChild('editPuchaseRequestForm', { static: false}) nameInput!: ElementRef;
  @ViewChild('editPuchaseRequestForm') nameInput: any;
  constructor(
    private purchaseService: PurchaseRequestService,
    public dateservice: DateService,
    private cdr: ChangeDetectorRef,
    public global: GlobalComponent,
    public purchaseListService: PurchaseListService,
    public toastService: ToastrService,
    public datepipe: DatePipe,
    public fb: FormBuilder,
    public general: GeneralService,
    public commonhttp: CommonHttpService
  ) {
    this.DeleteForm = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });
    this.gridPurchase = this.purchaseListService;
    if (this.global.OnboardingLoginType != "onboardLogin") {
      this.global.checkforlogout();
    } else {
      this.global.checkforonBoardLogout();
    }
    this.global.checkforlogout();

    this.form = fb.group({
      zipCode: [""],
      phone: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      email: ["", [Validators.required, Validators.email]],
    });
  }
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    if (this.global.globalAgencyId == undefined || this.global.globalAgencyId == "" || this.global.globalAgencyId == null || this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      if (this.global.OnboardingLoginType != "onboardLogin") {
        this.showNoAgenyError = true
      }
    }
    else {
      this.showNoAgenyError = false
    }
    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.getAuthorizationType();
    this.filterSettings = { type: "Menu" };
    this.formatDateOptions = { type: "datetime", format: "MM/dd/yyyy" };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[5],
      pageSizes: this.pageSizes,
    };

    if (this.purchaseEmit.clientToPurchase) {
      this.purchaselistBo.clientId = this.purchaseEmit.clientid;
      this.getPurchaseGridlist();
    } else {
      this.getPurchaseGridlist();
    }
    if (this.global.OnboardingLoginType != "onboardLogin") {
      this.getClientList();
    }
    this.GetPurchaseTypeLov();
    this.getVendorList();
    this.GetPurchaseStatusLov();
    this.getstatus();
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
    this.getpermission()
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      if (this.purchaseEmit.clientToPurchase) {
        params.append("pagecode", "Client");

      }
      else {
        params.append("pagecode", "PURCHASELIST");
      }
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.purchaseService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  statuslist: any;
  getstatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statuslist = JSON.parse(data);
        this.vendor.statusLid = this.statuslist.filter(
          (st) => st.lovCode == "ACTIVE"
        )[0].id;
      });
  }

  clickaddpurchase() {
    this.purchaseBO = new PurchaseRequestBO();
    this.purchaseFileBo = new PurchaseReceiptBO();
    this.payer = "";
    this.serviceName = "";
    this.isview = false;
    this.AuthList = [];
    this.purchaseType = [];
    this.EditPurchaseType='';
  //  this.changeModalSizeMd();
    this.plusPurchaseRequest(0);
  }
  getClientList() {
    this.purchaseService
      .getClientDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.clientList = data;
        if (this.global.OnboardingLoginType != 'onboardLogin' && this.purchaseEmit.clientToPurchase == true) {
          this.purchaseBO.clientId = this.purchaseEmit.clientid;
          this.purchaseClientName = this.clientList.filter(
            (s) => s.Key == this.purchaseEmit.clientid
          )[0].Value;
        }
      });
  }
  getAuthList(index = null) {
    if(index != null && index  >  0){
      // this.PurchaseRequestList[index].clientAuthorizationId=this.PurchaseRequestList[index-1].clientAuthorizationId;
      // this.PurchaseRequestList[index].payerName=this.PurchaseRequestList[index-1].payerName
      // this.PurchaseRequestList[index].serviceName=this.PurchaseRequestList[index-1].serviceName;
      // this.PurchaseRequestList[index].serviceId=this.PurchaseRequestList[index-1].serviceId
      // this.PurchaseRequestList[index].description=this.PurchaseRequestList[index-1].description;
      // this.PurchaseRequestList[index].clientAuthorizationId=this.PurchaseRequestList[index-1].clientAuthorizationId;
      // this.PurchaseRequestList[index].clientName=this.global.globalclientdata.name
      return
    }
    let date = "";
    if(index == null){
      date = this.PurchaseRequest.requestDate;
    }else{
      date = this.PurchaseRequestList[index].requestDate;
    }
    date != null && date != undefined && date != ""
        ? this.global.getDateTimeString(date)
        : null;
    if (date != null && date != undefined && date != "") {
      let params = new URLSearchParams();
      if (this.global.OnboardingLoginType != 'onboardLogin') {
        params.append("ClientId", this.purchaseEmit.clientid);
      }
      params.append("dateTime", date);
      this.purchaseService
        .GetAuthForPurchaseRequest(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.AuthList = [];
            this.AuthList = JSON.parse(data);
            // var purchaseModal=
           // this.changeModalSizeXl();
           this.resetPurchaseRequestList();
          },
          (err: HttpErrorResponse) => {
            this.toastService.error(err.error, "error");
            setTimeout(() => {
              this.toastService.clear();
            }, 8000);
          }
        );

    }
    else {
      this.AuthList = []
      this.payer = ""
      this.serviceName = ""

    }
  }
  clearInputFeild() {
    if (this.purchaseBO.requestDate == null || this.purchaseBO.requestDate == undefined || this.purchaseBO.requestDate == '') {
      this.payer = ""
      this.serviceName = ""
      this.purchaseBO = new PurchaseRequestBO();
    }

  }
  savePurchase() {
    this.IsButtonDisable = true;
   
this.PurchaseRequestList.forEach(e=>{
  if(e.requestDate != null  || e.requestDate != undefined) {
      e.requestDate=this.global.getDateTimeString(e.requestDate);
  }
  e.totalAmount= e.totalAmount!=null && e.totalAmount != undefined? parseFloat(e.totalAmount):null
  e.clientId=this.global.globalclientdata.id;
})
// let body = new FormData();
// this.PurchaseRequestList.forEach((e, index) => {  
//   Object.keys(e).forEach((key) => {   
//     if (key === 'attachMent' && e[key]) {      
//       body.append(`purchaseRequests[${index}].${key}`, e[key], e[key].name);
//     } else {      
//       if (e[key] !== null && e[key] !== undefined) {
//         body.append(`purchaseRequests[${index}].${key}`, e[key]);
//       }
//     }
//   });
// });

    this.purchaseService
      .savePurchaseRequest(this.PurchaseRequestList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.toastService.success("Purchase Request Saved Successfully");
          document.getElementById("PurchaseModalopen").click();
          this.getPurchaseGridlist();

        },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  GetPurchaseTypeLov() {
    let params = new URLSearchParams();
    params.append("ListCode", "TYPEOFPURCHASE");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.purchaseTypeList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  GetPurchaseStatusLov() {
    let params = new URLSearchParams();
    params.append("ListCode", "PURCHASEREQUESTSTATUS");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.PurchaseStatusList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  getVendorList() {
    this.purchaseService
      .getVendorList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.vendorList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  showLocationColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  newdates(event, type, name,index?) {
    this.payer = this.serviceName = this.purchaseBO.clientAuthorizationId = '';
    if (type == "inputchange") {
      if (name == "date") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          if(index != null)
            this.PurchaseRequestList[index].requestDate = val1;
          else
            this.PurchaseRequest.requestDate=val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "date") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          // this.PurchaseRequestList[index].requestDate = val1;
          if(index != null)
            this.PurchaseRequestList[index].requestDate = val1;
          else
            this.PurchaseRequest.requestDate=val1;
        }
      }
    }
   // console.log(this.PurchaseRequestList[index].requestDate, "rrrrrrrrr");

  }

  purchaseTypeFilter(data,index?) {

    if (data != null && data != undefined && data != "") {
      let purchaseType = this.purchaseTypeList.filter(
        (s) => s.id == data
      )[0].lovName;

      if(index !=null) {
        this.purchaseType[index]=purchaseType
        this.PurchaseRequestList[index].purchaseTypeName=purchaseType;      
        this.PurchaseRequestList[index].purchaseTypeLid=data;
      } else {
          this.PurchaseRequest.purchaseTypeName=purchaseType;
          this.PurchaseRequest.purchaseTypeLid=data;
          this.EditPurchaseType=purchaseType;
      }
     
    } else {
      this.purchaseType =[];
      this.EditPurchaseType='';
    }
  }

  getauthoraization(val) {
    this.serviceName = val.serviceName;
    this.payer = val.payerName;
    this.purchaseBO.serviceId = val.serviceId;
    this.purchaseBO.description = val.serviceDescription;
    this.purchaseBO.clientAuthorizationId = val.clientAuthorizationId;
  }

  getPurchaseGridlist() {
    if(this.DecimalColumns.includes(this.purchaselistBo.field.toUpperCase())){
      // this.purchaselistBo.value = this.purchaselistBo.value + '';
      this.purchaselistBo.type = "decimal";
    }
    if(this.purchaselistBo.type != "string" && this.purchaselistBo.value == "" 
      || this.purchaselistBo.value == undefined || this.purchaselistBo.value == null){
        this.purchaselistBo.field = "clientName";
        this.purchaselistBo.orderColumn = "clientName";
          this.purchaselistBo.matchCase = false;
          this.purchaselistBo.operator = "startswith";
          this.purchaselistBo.value = "";
          this.purchaselistBo.type = "string";
    }
    this.purchaseListService.execute(this.purchaselistBo);
    this.gridPurchase.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => { },
      (err: HttpErrorResponse) => {
        this.toastService.error(err.error, "error");
        setTimeout(() => {
          this.toastService.clear();
        }, 8000);
      }
    );
  }
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result as string);
    reader.onerror = error => reject(error);
  });
  
  async onDOCFileChanged(files, index?) {
    let val = files.item(0); // Get the first file from the file input
    
    if(files.length <= 0){
      if(index != null){
        this.PurchaseRequestList[index].attachMent = "";
        this.PurchaseRequestList[index].fileName = null;
        let fileInput = document.getElementById(`purchase-request-file-input-${index}`);
        fileInput.textContent = 'Please Select File';
      }else{
        this.PurchaseRequest.attachMent = "";
        this.PurchaseRequest.fileName = null;
      }
      return;
    }
    let fileMb = (val != null || val != undefined) ? (val.size/(1024**2)) * 1.3 : 0;
    let FILESIZELIMIT = 3;
    if(val != null && fileMb >= FILESIZELIMIT){
      this.toastService.warning(`File Size Should Be Less Than ${FILESIZELIMIT}mb`);
    }
    if (index != null) {
      // Update the PurchaseRequestList at the given index
      const base64Content = await this.tobase64(val);
      if (base64Content) {
        this.PurchaseRequestList[index].attachMent = base64Content.toString(); // Assign Base64 string
        this.PurchaseRequestList[index].fileName = val?.name;
        let fileInput = document.getElementById(`purchase-request-file-input-${index}`);
        fileInput.textContent = val.name;
      } else {
        this.toastService.error('Failed to convert file to Base64');
      }
    } else {
      // Update the single PurchaseRequest object
      const base64Content = await this.tobase64(val);
      if (base64Content) {
        this.PurchaseRequest.attachMent = base64Content.toString();
        this.PurchaseRequest.fileName = val?.name;
      }     
      
    }
  }

  getTotal(PurchaseRequest,index) {
    if (
      PurchaseRequest.quantity != null &&
      PurchaseRequest.quantity != undefined &&
      PurchaseRequest.rate != undefined &&
      PurchaseRequest.rate != null
    ) {
      PurchaseRequest.totalAmount =
        (PurchaseRequest.quantity * PurchaseRequest.rate).toFixed(2);
        if(index != null) {
          this.PurchaseRequestList[index].rate =PurchaseRequest.rate;
          this.PurchaseRequestList[index].quantity=PurchaseRequest.quantity; 
          this.PurchaseRequestList[index].totalAmount=   PurchaseRequest.totalAmount;
        } else {
          this.PurchaseRequest.totalAmount=PurchaseRequest.totalAmount;
        }
     
      
    }
  }

  clickEditview(purchaseData: PurchaseRequestBO) {

   // this.changeModalSizeMd();
    this.PurchaseRequest = JSON.parse(JSON.stringify(purchaseData));
    this.purchaseId = purchaseData.id;
    if (this.global.OnboardingLoginType != 'onboardLogin' && this.purchaseEmit.clientToPurchase != true) {
      this.purchaseEmit.clientid = this.PurchaseRequest.clientId;
    }
    this.getAuthId = purchaseData.clientAuthorizationId;
    this.purchaseClientName = purchaseData.clientName;
    this.PurchaseRequest.requestDate = this.datepipe.transform(
      purchaseData.requestDate,
      "MM/dd/yyyy"
    );
    this.serviceName = purchaseData.serviceName;
    this.payer = purchaseData.payerName;
    this.fileUpload = purchaseData?.fileName;
    this.isview = true;
    this.purchaseTypeFilter(purchaseData.purchaseTypeLid,null);
    this.PurchaseRequest.vendorId = this.vendorList.filter(
      (st) => st.id == purchaseData.vendorId
    )[0]?.id;
    // this.getAuthList();
    if(this.nameInput) this.nameInput.nativeElement.value = '';   

// Convert URL to Base64
if(this.PurchaseRequest.returnDocument != null && this.PurchaseRequest.returnDocument != '') {
  // let fileInput = document.getElementById("purchase-request-edit-file-input");
  //   fileInput.textContent = purchaseData?.fileName;
   // this.nameInput.nativeElement.value=purchaseData?.fileName;
  let base64Url: string;
  let finalString:string;
  const mimeType =this.getMimeType(this.PurchaseRequest.fileName);
  console.log(mimeType,"mimeType");
  if(mimeType != '') {
   // base64Url = btoa(this.PurchaseRequest.returnDocument);   
   
    let params = new URLSearchParams();
    params.append("ContainerName", this.PurchaseRequest.containerName);
    params.append("FilePath", this.PurchaseRequest.filePath);
    this.purchaseService
        .getBase64Purchase(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {            
          data=JSON.parse(data);
          finalString = `data:${mimeType};base64,${data.result}`;
          console.log(finalString,"finalString");
          this.PurchaseRequest.attachMent=finalString;      
           this.setFileFromBase64(finalString,mimeType,purchaseData?.fileName)

          },
          (err: HttpErrorResponse) => {
            this.IsButtonDisable = false;
            this.toastService.error(err.error, "error");
            setTimeout(() => {
              this.toastService.clear();
            }, 8000);
          }
        );  
  }
 
  
}

//const finalString = `data:${mimeType};base64,${base64String}`;


  }

   getMimeType(fileName: string): string {
    // Extract the file extension
    if(fileName==null && fileName == undefined) {
        return ''
    }
    let extention=fileName.split(".");
    const ext = extention[1].toLowerCase();
    console.log(ext,"ext")
    // Map file extensions to MIME types
    const mimeTypes: { [key: string]: string } = {
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'xls': 'application/vnd.ms-excel',
        'csv': 'text/csv',    
        'pdf': 'application/pdf',   
        'jpeg': 'image/jpeg',  
        'jpg': 'image/jpeg',  
        'png': 'image/png',   
    };   
    return mimeTypes[ext]; 
}

  downloadFile(data) {
    var data1 = data.returnDocument;
    var link = document.createElement('a');
    link.href = data1;
    link.download = data.fileName;
    link.click();
  }

  clickClose() {    
   this.PurchaseRequest= new PurchaseRequestBO();
   this.PurchaseRequestList=[]
  }
  AcceptRequest() {
    this.IsButtonDisable = true;
    let params = new URLSearchParams();
    params.append("PurchaseId", this.purchaseId);
    params.append("ClientId", this.getAuthId);

    this.purchaseService
      .AcceptPurchaseRequest(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          if (data) {
            this.acceptError = data;

            document.getElementById("Authmodal").click();
          } else {
            this.toastService.success("Request Accepted Successfully");
            document.getElementById("AcceptModal").click();
            this.getPurchaseGridlist();
          }
        },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  RejectRequest() {
    this.IsButtonDisable = true;
    let params = new URLSearchParams();
    params.append("PurchaseId", this.purchaseId);
    this.purchaseService
      .RejectPurchaseRequest(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.toastService.success("Request Rejected Successfully");
          this.purchaseId = "";
          document.getElementById("RejectModal").click();
          this.getPurchaseGridlist();
        },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  saveAccept() {
    this.IsButtonDisable = true;
    if(this.selectedpurchases.length >0){
      this.purchaseService.AcceptAfterMultipleError(this.selectedpurchases).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => { 
           this.IsButtonDisable = false;
            this.toastService.success("Purchase Request Accept Successfully");
            document.getElementById("Authmodal").click();
           
            this.getPurchaseGridlist();               
      },
        (err: HttpErrorResponse) => {   
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);     
        })
    } else {
      let params = new URLSearchParams();
      params.append("PurchaseId", this.purchaseId);
      params.append("ClientId", this.getAuthId);
      this.purchaseService
        .AcceptAfterError(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.IsButtonDisable = false;
            this.toastService.success("Request Accepted Successfully");
  
            this.purchaseId = "";
            document.getElementById("Authmodal").click();
            document.getElementById("AcceptModal").click();
            this.getPurchaseGridlist();
          },
          (err: HttpErrorResponse) => {
            this.IsButtonDisable = false;
            this.toastService.error(err.error, "error");
            setTimeout(() => {
              this.toastService.clear();
            }, 8000);
          }
        );
    }
   
  }

  filterApply() {
    this.validation();
    this.getPurchaseGridlist();
  }

  validation() {
    if (this.FromDateFilter == null || this.FromDateFilter == '' || this.FromDateFilter == undefined) {
      this.toastService.error("select start date");
      return;
    }
    else if (this.EndDateFilter == null || this.EndDateFilter == undefined || this.EndDateFilter == '') {
      this.toastService.error("select end date");
      return;
    }
    else if ((this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '')
      && (this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '')) {
      if (new Date(this.FromDateFilter).getTime() > new Date(this.EndDateFilter).getTime()) {
        this.toastService.error("End date should greater than start date");
        return;
      }
    }
    this.purchaselistBo.startDate = this.global.getDateTimeString(this.FromDateFilter)
    this.purchaselistBo.endDate = this.global.getDateTimeString(this.EndDateFilter)
  }

  Refresh() {
    if (this.purchaseEmit.clientToPurchase) {
      this.purchaselistBo.clientId = this.purchaseEmit.clientid;
      this.purchaselistBo.purchaseTypeLid = null;
      this.purchaselistBo.requestStatusLid = null;
      this.getPurchaseGridlist();
    } else {
      this.purchaselistBo.clientId = null;
      this.purchaselistBo.purchaseTypeLid = null;
      this.purchaselistBo.requestStatusLid = null;
      this.getPurchaseGridlist();
    }
  }

  public onActionComplete(G) {
    this.purchaselistBo.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.purchaselistBo.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.purchaselistBo.type = G.columnType;
    }
  }

  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();
    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.purchaselistBo.orderColumn = state.sorted[0].name;
        this.purchaselistBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.purchaselistBo.field = state.action.currentFilterObject.field;
      this.purchaselistBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.purchaselistBo.operator = state.action.currentFilterObject.operator;
      this.purchaselistBo.value = state.action.currentFilterObject.value;
      this.purchaselistBo.orderColumn =
        state.action.currentFilterObject.field;
        if(this.purchaselistBo.type == 'number'){
          this.purchaselistBo.value = (this.purchaselistBo.value != null && this.purchaselistBo.value != undefined)
          ? this.purchaselistBo.value.toString() : null;
        }
    } else {
      if (
        this.documentType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.purchaselistBo.field = this.purchaselistBo.orderColumn = "clientName";
        this.purchaselistBo.matchCase = false;
        this.purchaselistBo.operator = "startswith";
        this.purchaselistBo.value = "";
        this.purchaselistBo.orderColumn = "clientName";
        this.purchaselistBo.type = "string";
      }
    }

    this.getPurchaseGridlist();
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  PhoneFormat(value) {
    if (value == "phone") {
      this.vendor.phone = this.general.converPhoneGoogleLib(this.vendor.phone);
    }
  }
  CaseCreateupdate() {
    this.vendor = new VendorBO();
  }

  SaveVendor() {
    this.IsButtonDisable = true;
    if (this.vendor.id == "00000000-0000-0000-0000-000000000000") {
      var saveList: VendorBO = JSON.parse(JSON.stringify(this.vendor));
      this.purchaseService
        .saveupdateVendor(saveList)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            this.toastService.success("saved  Successfully", "vendor saved");
            document.getElementById("opencasemanModal1").click();
            this.getVendorList();
          },
          (err) => {
            this.IsButtonDisable = false;
            this.toastService.error(err.error);
          }
        );
    }
  }
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.serviceName = rowList.serviceName;
    this.payer = rowList.payerName;
   // this.PurchaseRequest.clientName=this.global.cli
    this.PurchaseRequest.serviceName = rowList.serviceName;
    this.PurchaseRequest.payerName=rowList.payerName;
    this.PurchaseRequest.serviceId = rowList.serviceId;
    this.PurchaseRequest.description = rowList.serviceDescription;
    this.PurchaseRequest.clientAuthorizationId = rowList.clientAuthorizationId;
    
    // this.PurchaseRequestList[this.selectedIndex].payerName=rowList.payerName
    // this.PurchaseRequestList[this.selectedIndex].serviceName=rowList.serviceName;
    // this.PurchaseRequestList[this.selectedIndex].serviceId=rowList.serviceId
    // this.PurchaseRequestList[this.selectedIndex].description=rowList.description;
    // this.PurchaseRequestList[this.selectedIndex].clientAuthorizationId=rowList.clientAuthorizationId;
    // this.PurchaseRequestList[this.selectedIndex].clientName=this.global.globalclientdata.name;
    // this.PurchaseRequestList[this.selectedIndex].item=rowList.item;
    // this.PurchaseRequestList[this.selectedIndex].description=rowList.description;

    if(this.PurchaseRequestList != null && this.PurchaseRequestList != undefined){
      for(let i=0; i<this.PurchaseRequestList.length; i++){
        if(i != 0){ this.PurchaseRequestList[i].requestDate = null; }
        this.PurchaseRequestList[i].payerName=rowList.payerName
        this.PurchaseRequestList[i].serviceName=rowList.serviceName;
        this.PurchaseRequestList[i].serviceId=rowList.serviceId
        this.PurchaseRequestList[i].description=rowList.description;
        this.PurchaseRequestList[i].clientAuthorizationId=rowList.clientAuthorizationId;
        this.PurchaseRequestList[i].clientName=this.global.globalclientdata.name;
        this.PurchaseRequestList[i].item=rowList.item;
        // this.PurchaseRequestList[i].description=rowList.description;
      }
    }
    this.UpdateDatePickerRestrictionRange(rowList.startDate, rowList.endDate);
  }
  ngAfterContentChecked() {
    // this.purchaseBO.requestDate =(this.purchaseBO.requestDate != null &&this.purchaseBO.requestDate != undefined && this.purchaseBO.requestDate != "") ? this.datepipe.transform(this.purchaseBO.requestDate, "MM/dd/yyyy"): null;
   // this.cdr.detectChanges();
  }

  changeModalSizeXl() {
    let doc = document.getElementById('smallModal');
    doc.classList.remove('modal-lg');
    doc.classList.add('modal-xl')

    let getcol = document.getElementById("fisrtcol");
    getcol.classList.remove('col-12');
    getcol.classList.add('col-6');
  }
  changeModalSizeMd() {
    let doc = document.getElementById('smallModal');
    doc.classList.remove('modal-xl');
    doc.classList.add('modal-lg')
    let getcol = document.getElementById("fisrtcol");
    getcol.classList.remove('col-6');
    getcol.classList.add('col-12');
  }


  exportCsv() {
    this.validation();
    this.purchaseService.exportcsv(this.purchaselistBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Purchase Export";
      a.click();

    },
      (err: HttpErrorResponse) => {
        this.toastService.error(
          err.error

        );
      })

  }

  b64toBlob = (b64Data, contentType: any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  clickDeleteview(purchaseId) {
    this.DeleteForm.reset();
    this.deletebo.purchase_id = purchaseId;
  }

  DeletePurchaseRequest() {
    this.IsButtonDisable = true;
    let url = "api/PurchaseRequest/DeletePurchase?";
    this.commonhttp.saveorUpdateFunctionwithResponseTypeJson(this.deletebo, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.deletebo = new DeletepermissionBO();
      this.validationError = false;
      this.toastService.success(
        'Purchase Request deleted successfully!'
      ), 8000;
      document.getElementById("openPurchasedeleteModal").click();
      this.getPurchaseGridlist();
      this.validationError = false;
    },
      (err: any) => {
        this.IsButtonDisable = false;
        this.validationError = false;
        this.toastService.error(err);
      }
    );
  }
  //.....................................................passvalid.................................................
  passvalid(event) {
    let str = event.target.value;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.validationError = false;
    }
    else {
      this.validationError = true;
    }

  }

  //...................................................CancelDelete...................................................
  CancelDelete() {
    this.deletebo = new DeletepermissionBO();
  }

  bulkUpdateService;
  bulkUpdateAuthId;
  bulkServiceId;
  //....................................rowSelected........................................................
  rowSelectedForBulkVisitUpdate(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.bulkUpdateService = rowList.serviceCodeName;
    this.bulkServiceId = rowList.serviceId;
    this.bulkUpdateAuthId = rowList.id;

  }
  UpdateAuthorizationList: any = [];
  public UpdateAuthorizationinitialPage: PageSettingsModel;
  IsBulkUpdate: boolean = false;
  saveErr: any;
  getBulkUpdateActiveAuths() {
    this.UpdateAuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: 10, pageSizes: [10, 15, 20, 25] };
    let params = new URLSearchParams();
    params.append("clientId", this.purchaselistBo.clientId);
    params.append("fromDate", this.global.getDateTimeString(this.FromDateFilter));
    params.append("toDate", this.global.getDateTimeString(this.EndDateFilter));
    params.append("authType", "GOODS");
    this.purchaseService.getAcitveAuths(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UpdateAuthorizationList = data;
      this.IsBulkUpdate = true;
    })
  }
  errorList: any[] = [];
  purchasesBulkUpdateBO: BulkT2025UpdateBO = new BulkT2025UpdateBO()
  updatebulktransactions() {
    this.IsBulkUpdate = false;
    this.IsButtonDisable = true;

    this.purchasesBulkUpdateBO.clientId = this.purchaselistBo.clientId;
    this.purchasesBulkUpdateBO.serviceId = this.purchaselistBo.serviceId;
    this.purchasesBulkUpdateBO.updateServiceId = this.bulkServiceId;
    this.purchasesBulkUpdateBO.updateAuthId = this.bulkUpdateAuthId;
    this.purchasesBulkUpdateBO.startDate = this.global.getDateTimeString(this.FromDateFilter);
    this.purchasesBulkUpdateBO.endDate = this.global.getDateTimeString(this.EndDateFilter);

    this.purchaseService.updateMulitplePurchases(this.purchasesBulkUpdateBO).pipe(takeUntil(this.onDestroy$)).
      subscribe((data: any) => {
        this.IsButtonDisable = false;

        if (data.length == 0) {
          this.toastService.success('Timesheets Updated Successfully!');
          this.getPurchaseGridlist();
          document.getElementById("updateauth").click();

        } else {
          this.errorList = data;
          if(this.errorList?.length > 0) {
            document.getElementById("errorpopup").click();
          }
        }
      },
        (err) => {
          this.IsButtonDisable = false;
          this.toastService.error(err, 'error');
          setTimeout(() => {
            this.saveErr = ""
          }, 8000);
        }
      );
  }

  closeBulkUpdate() {
    this.IsBulkUpdate = false;
  }

  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'balanceAmount') {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add('mark');
      }
    }
  }

  //////////////////////////Date Picker Date Change///////////////////////////////////////////////////////////////////////
  FromDateFilter: any
  EndDateFilter: any;
  filterDates(event, type, name) {

    if (type == "inputchage") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
    }
    if (type == "datechagned") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;

        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
        }
      }
    }
  }

  AuthTypeList:any[] = [];
  GoodsAuthLid: string;
  //..............................................getAuthorizationType.................................
  getAuthorizationType() {
    let params = new URLSearchParams();
    params.append("ListCode", "AUTHORIZATIONTYPE");
    this.commonhttp.getStatus(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.AuthTypeList = data;
      this.GoodsAuthLid  = this.AuthTypeList?.find(x => x.lovCode?.trim().toUpperCase() == "GOODS")?.id;
      // console.log(data, this.GoodsAuthLid)
      if(this.GoodsAuthLid)
        this.getServiceList();
    }, (err: any) => {
      if (err) {
        this.toastService.error(err, 'Error'), 8000;
      }
    })
  }

  serviceList: any = []
  getServiceList() { 
    let params = new URLSearchParams();
    params.append("AuthTypeLid", this.GoodsAuthLid);
    this.purchaseService.GetServiceDropdownBasedonAuthType(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList = data;
    })
  }

  plusPurchaseRequest(index)  {
    let purchase:PurchaseRequestBO=new PurchaseRequestBO();
    purchase.requestDate=null;
    purchase.clientName=this.global.globalclientdata.name;
    this.PurchaseRequestList.push(purchase);
   // this.PurchaseRequest.clientName=this.global.globalclientdata.name;
    this.selectedIndex=index;
    // console.log(this.PurchaseRequestList,"purchase");
    // console.log(this.global.globalclientdata,"global");
    if(index >0)  
    {
      index = this.PurchaseRequestList.length-1;
      this.PurchaseRequestList[index].clientAuthorizationId=this.PurchaseRequestList[0].clientAuthorizationId;
      this.PurchaseRequestList[index].payerName=this.PurchaseRequestList[0].payerName
      this.PurchaseRequestList[index].serviceName=this.PurchaseRequestList[0].serviceName;
      this.PurchaseRequestList[index].serviceId=this.PurchaseRequestList[0].serviceId
      this.PurchaseRequestList[index].description=this.PurchaseRequestList[0].description;
      this.PurchaseRequestList[index].clientAuthorizationId=this.PurchaseRequestList[0].clientAuthorizationId;
      this.PurchaseRequestList[index].clientName=this.global.globalclientdata.name;
      // this.PurchaseRequestList[index].requestDate=this.PurchaseRequestList[index-1].requestDate;
      this.PurchaseRequestList[index].item=this.PurchaseRequestList[0].item;
      this.PurchaseRequestList[index].description=this.PurchaseRequestList[0].description;
      this.PurchaseRequestList[index].quantity = this.PurchaseRequestList[0].quantity;
      this.PurchaseRequestList[index].rate = this.PurchaseRequestList[0].rate;
      this.PurchaseRequestList[index].totalAmount = this.PurchaseRequestList[0].totalAmount;
    }
   

  }
  removePurchaseRequest(Index) {
   // this.selectedIndex=Index;  
    if (this.PurchaseRequestList.length > 1) {
      this.PurchaseRequestList.splice(Index, 1);
    }
  }
  clearPurchase(I) {
      this.PurchaseRequestList[I] = new PurchaseRequestBO();
    }
    selectedIndex:number;
    selectData(data,index){
      this.selectedIndex=index;
      this.PurchaseRequest=data;
    }

    AssignItemValues(PurchaseRequest,index){
      this.PurchaseRequestList[index].item=PurchaseRequest.item;
    }
    AssignDescriptionValues(PurchaseRequest,index)  {
      this.PurchaseRequestList[index].description=PurchaseRequest.description;
    }
    UpdtatePurchase() {
  // console.log(this.PurchaseRequest.requestDate, "this.purchaseBO.requestDate")
     this.PurchaseRequest.requestDate =
      this.PurchaseRequest.requestDate != null &&
        this.PurchaseRequest.requestDate != undefined &&
        this.PurchaseRequest.requestDate != ""
        ? this.global.getDateTimeString(this.PurchaseRequest.requestDate)
        : null;
    this.PurchaseRequest.requestStatusLid = this.PurchaseStatusList.filter(
      (s) => s.lovCode == "PENDING"
    )[0].id;

    let body = new FormData();
    if (this.global.OnboardingLoginType != 'onboardLogin') {
      body.append("clientId", this.purchaseEmit.clientid);
    }
    if (this.isview) {
      body.append("Id", this.PurchaseRequest.id);
      if(this.PurchaseRequest.purchaseReceiptId != null && this.PurchaseRequest.purchaseReceiptId != undefined) body.append("purchaseReceiptId", this.PurchaseRequest.purchaseReceiptId);
    }
    body.append("requestDate", this.PurchaseRequest.requestDate);
    body.append("clientAuthorizationId", this.PurchaseRequest.clientAuthorizationId);
    body.append("serviceId", this.PurchaseRequest.serviceId);
    if (
      this.PurchaseRequest.item != null &&
      this.PurchaseRequest.item != undefined &&
      this.PurchaseRequest.item != ""
    ) {
      body.append("item", this.PurchaseRequest.item);
    }
    if (
      this.PurchaseRequest.description != null &&
      this.PurchaseRequest.description != undefined &&
      this.PurchaseRequest.description != ""
    ) {
      body.append("description", this.PurchaseRequest.description);
    }
    body.append("quantity", this.PurchaseRequest.quantity.toString());
    body.append("rate", this.PurchaseRequest.rate.toString());
    body.append("totalAmount", this.PurchaseRequest.totalAmount.toString());
    body.append("purchaseTypeLid", this.PurchaseRequest.purchaseTypeLid);
    body.append("requestStatusLid", this.PurchaseRequest.requestStatusLid);
    if (
      this.PurchaseRequest.vendorId != null &&
      this.PurchaseRequest.vendorId != undefined &&
      this.PurchaseRequest.vendorId != ""
    ) {
      body.append("vendorId", this.PurchaseRequest.vendorId);
    }
    let purchaseType = this.purchaseTypeList.filter(
      (s) => s.id == this.PurchaseRequest.purchaseTypeLid
    )[0].lovName;
    if(purchaseType == "Client Reimbursement") {
      body.append("attachMent", this.PurchaseRequest.attachMent);
      body.append("fileName",this.PurchaseRequest.fileName)
    } 

      this.purchaseService
      .UpdatePurchaseRequest(body)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.toastService.success("Purchase Request Updated Successfully");
          document.getElementById("PurchaseModalEdit").click();
          this.getPurchaseGridlist();

        },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
    }
    ValidateMultiplePurchaseRequst(){
      let purchaseList: PurchaseRequestBO[] = this.PurchaseRequestList;
      let isValid: boolean = true;
      let filePlayloadSize = 0;
      for(let i = 0; i < purchaseList.length; i++){
        let element = this.PurchaseRequestList[i];
        if(element.requestDate == null || element.requestDate == undefined || element.requestDate == ''){
          let message = "Please Enter Request Date";
          this.toastService.error(message);
          isValid = false;
        }else if(element.payerName == null || element.payerName == undefined || element.payerName == ''){
          let message = "Please Select Service";
          this.toastService.error(message);
          isValid = false;
        }else if(element.serviceName == null || element.serviceName == undefined || element.serviceName == ''){
          let message = "Please Select Service";
          this.toastService.error(message);
          isValid = false;
        }else if(element.quantity == null || element.quantity == undefined || element.quantity <= 0){
          let message = "Please Enter Quantity";
          this.toastService.error(message);
          isValid = false;
        }else if(element.rate == null || element.rate == undefined || element.rate <= 0){
          let message = "Please Enter Rate";
          this.toastService.error(message);
          isValid = false;
        }else if(element.purchaseTypeLid == null || element.purchaseTypeLid == undefined || element.purchaseTypeLid == ''){
          let message = "Please Select Puchase Type";
          this.toastService.error(message);
          isValid = false;
        }
        if(isValid != false && element.purchaseTypeLid != null && element.purchaseTypeName?.toLowerCase() == "vendor payment"){
          if(element.vendorId == null || element.vendorId == undefined || element.vendorId == ''){
            let message = "Please Select Vendor";
            this.toastService.error(message);
            isValid = false;
          }
        }else if(isValid != false && element.purchaseTypeLid != null && element.purchaseTypeName?.toLowerCase() == "client reimbursement"){
          if(element.attachMent == null || element.attachMent == undefined || element.attachMent == ''){
            let message = "Please Attach File";
            this.toastService.error(message);
            isValid = false;
          }
        }
        if(isValid != false && element.attachMent != null && typeof(element.attachMent) == "string" ){
            let fileInMB = this.calculateBase64Size(element.attachMent)/(1024 * 1024);
            filePlayloadSize += (fileInMB * 1.3);
            if(filePlayloadSize > 25){
              this.toastService.error("All Files Size Should Be Less Than 25MB");
              isValid = false;
            }
        }
        if(isValid == false){
          break;
        }
      };
      if(isValid){
        this.savePurchase();
      }
    }
    calculateBase64Size(base64): number {
      const base64Length = base64.split(",")[1]?.length || 0;
      return (base64Length * 3) / 4 - (base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0);
    }
    UpdateDatePickerRestrictionRange(sDate: string, eDate: string) {

      if(sDate == null || sDate==undefined || sDate=='' || eDate == null || eDate==undefined || eDate==''){
        return;
      }
      let startDate = new Date(sDate);
      let endDate = new Date(eDate);
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() + 1);
      let Options: IMyDpOptions = {
        dateFormat: "mm/dd/yyyy",
        showClearDateBtn: false,
        editableDateField: true,
        disableUntil: { year: startDate.getFullYear(), month: startDate.getMonth()+1, day: startDate.getDate() },
        disableSince: { year: endDate.getFullYear(), month: endDate.getMonth()+1, day: endDate.getDate() }
      };
      this.myDatePickerRestrictOptions = {
        ...this.myDatePickerRestrictOptions,
        ...Options
      }
      // console.log(this.myDatePickerRestrictOptions)
    }
    resetPurchaseRequestList(){
      if(this.PurchaseRequestList != undefined && this.PurchaseRequestList.length > 0){
        for(let i=0; i<this.PurchaseRequestList.length; i++){
          if(i != 0){ this.PurchaseRequestList[i].requestDate = null; }
          this.PurchaseRequestList[i].payerName= null;
          this.PurchaseRequestList[i].serviceName=null;
          this.PurchaseRequestList[i].serviceId="00000000-0000-0000-0000-000000000000";
          // this.PurchaseRequestList[i].description=null;
          this.PurchaseRequestList[i].clientAuthorizationId="00000000-0000-0000-0000-000000000000";
          this.PurchaseRequestList[i].item=null;
          this.PurchaseRequestList[i].description=null;
        }
      }
      this.PurchaseRequest.payerName = null;
      this.PurchaseRequest.serviceName = null;
      this.PurchaseRequest.serviceId = "00000000-0000-0000-0000-000000000000";
      // this.PurchaseRequest.description = null;
      this.PurchaseRequest.clientAuthorizationId = "00000000-0000-0000-0000-000000000000";
      this.PurchaseRequest.item = null;
      this.PurchaseRequest.description = null;

      const startDate = new Date(1976, 1, 1);
      const endDate = new Date(2100, 12, 31);
      let Options: IMyDpOptions = {
        dateFormat: "mm/dd/yyyy",
        showClearDateBtn: false,
        editableDateField: true,
        disableUntil: { year: startDate.getFullYear(), month: startDate.getMonth()+1, day: startDate.getDate() },
        disableSince: { year: endDate.getFullYear(), month: endDate.getMonth()+1, day: endDate.getDate() }
      };
      this.myDatePickerRestrictOptions = {
        ...this.myDatePickerRestrictOptions,
        ...Options
      }
    }

    setFileFromBase64(fialstring,mimeType,filename): void {
      // Decode the base64 string and create a Blob
      const base64Data = fialstring.split(',')[1]; 
      const binaryData = atob(base64Data); 
  
     
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
  
     
      const blob = new Blob([uint8Array], { type: mimeType });
  
      // Create a File object from the Blob
//       var splittedstr=mimeType.split("/")

//       let str1: string = "data";
// let str2: string = splittedstr[1];
// let result: string = str1.concat(str2);
      const file = new File([blob], filename, { type: mimeType });
  
     
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
  
     
      this.nameInput.nativeElement.files = dataTransfer.files;
    }
    selectedpurchases:MultipleAccecpt_RejectBO[]=[]
    acceptType:any;
    CheckBoxClickEvent(args) {
    
          this.selectedpurchases = [];
          if (args.checked && args.target.classList.contains("e-checkselectall")) {
             
              let rowsdata: any = this.grid.getSelectedRecords();            
              
              console.log(rowsdata,'rowsdata');
              const exportData = rowsdata.map(row => {
                const exportItem = new MultipleAccecpt_RejectBO();
                exportItem.purchaseReqId = row.id;  // Mapping the 'id' to 'purchaseReqId'
                exportItem.clientAuthId = row.clientAuthorizationId; // Mapping the 'clientAuthorizationId' to 'clientAuthId'
                return exportItem;
                
            });
            this.selectedpurchases=exportData
            console.log(this.selectedpurchases,'selectedpurchases')
             
          }
          else if (args.target.classList.contains("e-checkselect")) {
              let rowsdata: any = this.grid.getSelectedRecords();            
              
              console.log(rowsdata,'rowsdata');
              const exportData = rowsdata.map(row => {
                const exportItem = new MultipleAccecpt_RejectBO();
                exportItem.purchaseReqId = row.id;  // Mapping the 'id' to 'purchaseReqId'
                exportItem.clientAuthId = row.clientAuthorizationId; // Mapping the 'clientAuthorizationId' to 'clientAuthId'
                return exportItem;
            });
            
            console.log(exportData);
            this.selectedpurchases=exportData;
          }     
  }
  multipleaccept() {
    this.selectedpurchases.forEach(item => {
      item.acceptType = 'Accept';  
  });
    this.purchaseService.updateMulitpleAccept_sts(this.selectedpurchases).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      console.log(data,'data-----')
      if (data) {
        console.log('if');
        this.acceptError = data;
        console.log(this.acceptError);
        document.getElementById("Authmodal").click();       
      } else {
        console.log('else')
        this.toastService.success("Purchase Request Accept Successfully");
        document.getElementById("AcceptMultipleModal").click();
        this.getPurchaseGridlist();
      }    
          
    },
      (err: any) => { 
        console.log('err',err);
        if (err.error && typeof err.error === 'object') {
          console.log('Error details:', JSON.stringify(err.error, null, 2));  // Format and print the error object

          // Assuming err.error has a message field (adjust according to your API response format)
          this.acceptError = err.error.message || 'Purchase Bill Amount will exceed the remaining budget amount.Are you sure you want to proceed?';
      } else {
          // In case the error is not an object, directly assign the error text
          this.acceptError = err.error || 'Purchase Bill Amount will exceed the remaining budget amount.Are you sure you want to proceed';
      }
       // this.acceptError = err.error;
        console.log(this.acceptError);
        document.getElementById("Authmodal").click();
        document.getElementById("AcceptMultipleModal").click();

      })
  }
  multiplereject() {
    this.selectedpurchases.forEach(item => {
      item.acceptType = 'reject';  
    });
    this.purchaseService.updateMulitpleAccept_sts(this.selectedpurchases).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {     
      console.log(data,'data-----');      
      if(data) {
        console.log('if');
        this.acceptError = data;
        document.getElementById("Authmodal").click();        
      } 
        else {
          console.log('else');
          this.toastService.success("Purchase Request Accept Successfully");
          document.getElementById("AcceptMultipleModal").click();
          this.getPurchaseGridlist(); 
        }     
    },
      (err: any) => {    
        console.log('err',JSON.parse(err));
        this.acceptError = JSON.stringify(err.error);       
        console.log(this.acceptError);
        document.getElementById("Authmodal").click();
        document.getElementById("AcceptMultipleModal").click();
      })
  }
}

